<div class=" mt-4">
    <section>
      <div class="scrollmenu">
        <a [routerLink]="['/pos/businessinfo']"> Business-info </a>
        <a routerLinkActive = "active" class="active menu" [routerLink]="['/pos/customer/new']"> Customer </a>
        <a [routerLink]="['/pos/Employee/new']"> Employee </a>
        <a [routerLink]="['/pos/orders/new']"> Orders</a>
        <a [routerLink]="['/pos/taxfee/new']"> Tax Fee </a>
        <a [routerLink]="['/pos/category/new']"> Item-Category </a>
        <a [routerLink]="['/pos/item/new']"> Items </a>
        <a [routerLink]="['/pos/businesshour/new']"> Business-Hours </a>
        <!-- <a [routerLink]="['/pos/order/new']"> Order </a>
        <a [routerLink]="['/pos/orderreceipt/new']"> Order Receipt </a>
        <a [routerLink]="['/pos/payment/new']"> Payment </a>
        <a [routerLink]="['/pos/paymentrecipt/new']"> Payment Receipt </a>
        <a [routerLink]="['/pos/tip/new']"> Tips </a> -->

          <!--  <a [routerLink]="['/pos/orderregister']"> Order Register </a>  -->
          <!--  <a [routerLink]="['/pos/ordertype/new']"> Order Type </a> -->
          <!--   <a [routerLink]="['/pos/tender/new']">  Tender </a>  -->
    </div>

    </section>
    <section class="mt-2">
        <div class="">
            <div class="row">
                <div class="col-md-12">
                    <div class="text-right py-2">
                        <button class="btn dash-btns " [routerLink]="['/pos/customer/manage']">Manage Customer</button>
                    </div>
                </div>
                <div class="col-md-7">
                    <div class="card-1">
                        <div class="row">
                            <div class="col-md-12">
                                <!-- <div class="text-center mb-5">
                                    <img src="assets/img/new/view-trans.svg" />
                                </div> -->
                                <div class="text-center">
                                    <div class="col-md-12" *ngIf="isNewCustomer">
                                        <a c class="view-h gary-t  ">Lets create a new Customer here</a>
                                    </div>
                                    <div class="col-md-12" *ngIf="isUpdateCustomer">
                                        <a c class="view-h gary-t  ">Lets Update Customer here</a>
                                    </div>

                                </div>

                                <div class="py-3">
                                  <div class="col-md-12" *ngIf="isNewCustomer">
                                    <form #form="ngForm" class="addpaynow">
                                        <div class="form-group formgroup-tm">

                                            <div class="row pt-2">

                                                <div class="col-md-12">
                                                  
                                                    <div class="form-group formgroup-tm">
                                                        <label class="customlabel">Customer Id*</label>
                                                        <input class="formcontrol-user1 form-control" type="text" placeholder="Customer Id " id="CustomerId"
                                                            name="CustomerId" [formControl]="CustomerId" (change)=onChange()
                                                            required>

                                                    </div>
                                                    <div style="color:red;" *ngIf="isemployee">Customer Id is already exist
                                                    </div>

                                                    <span class="text-danger"
                                                        *ngIf="CustomerId.invalid && (CustomerId.dirty || CustomerId.touched)"></span>
                                                </div>
                                            </div>

                                            <div class="row pt-2">

                                                <div class="col-md-12">
                                                    
                                                    <div class="form-group formgroup-tm">
                                                        <label class="customlabel">Customer Name*</label>
                                                        <input class="formcontrol-user1 form-control" type="text" placeholder="Customer Name " id="CustomerName"
                                                            name="CustomerName" [formControl]="CustomerName" required>

                                                    </div>
                                                    <span class="text-danger"
                                                        *ngIf="CustomerName.invalid && (CustomerName.dirty || CustomerName.touched)">{{customerName()}}</span>
                                                </div>
                                            </div>
                                            <div class="row pt-2">

                                                <div class="col-md-12">
                                                   
                                                    <div class="form-group formgroup-tm">
                                                        <label class="customlabel">Email</label>
                                                        <input class="formcontrol-user1 form-control" type="text" placeholder="Email " id="Email" name="Email"
                                                            [formControl]="Email"
                                                            pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$"
                                                            (change)="onChangeid()">

                                                    </div>
                                                    <div style="color:red;" *ngIf="Emailerror">Email already exist</div>
                                                    <span class="text-danger"
                                                        *ngIf="Email.invalid && (Email.dirty || Email.touched)">{{Emailerrorss()}}</span>
                                                </div>
                                            </div>

                                            <div class="row pt-2">

                                                <div class="col-md-12">
                                                    
                                                    <div class="input-group form-group formgroup-tm prefix mb-0">
                                                        <label class="customlabel">Mobile No *</label>
                                                        <span class="input-group-addon" *ngIf="currency =='$'">+1</span>
                                                        <span class="input-group-addon" *ngIf="currency =='₹'">+91</span>
                                                        <input class="formcontrol-user1 form-control w-100" type="text" placeholder="Mobile No " id="MobileNo" maxlength="10"
                                                            name="MobileNo" [formControl]="MobileNo"
                                                            (change)="onChangemobile()">

                                                    </div>
                                                    <div style="color:red;" *ngIf="mobileerror">Mobile number already exist
                                                    </div>
                                                    <span *ngIf="mobileerrorvalidation" class="text-danger">
                                                        {{Mobileerrormessage}}
                                                    </span>
                                                    <!-- <span *ngIf="mobilenumberrequired"></span> -->
                                                    <!-- <span class="text-danger"
                                                        *ngIf="MobileNo.invalid && (MobileNo.dirty || MobileNo.touched)">{{phoneerrors()}}</span> -->
                                                </div>
                                            </div>
                                            <!-- <div class="row pt-2">

                                                  <div class="col-md-5 col-lg-4">
                                                    <label class="customlabel">Address <span
                                                            class="text-danger">*</span></label>
                                                </div>

                                                  <div class="col-md-12">
                                                    <div class="form-group formgroup-tm">
                                                        <input type="text" placeholder="Address " id="Address" name="Address" [formControl]="Address" >

                                                    </div>

                                                     <span class="text-danger" *ngIf="Address.invalid && (Address.dirty || Address.touched)">{{addresserrors()}}</span>
                                                </div>
                                            </div>
                                            -->
                                            <div class="row pt-2">
                                                <div class="col-md-12">
                                                    
                                                    <div class="form-group formgroup-tm">
                                                        <label class="customlabel">Birth Day</label>
                                                        <input class="formcontrol-user1 form-control" type="date" placeholder="Birth Day " id="BirthDay"
                                                            name="BirthDay" [formControl]="BirthDay"
                                                          >
                                                        <!-- <input type="date"  placeholder="From Date" id="fromdate"
                                                        [formControl]="fromdate" max="{{datePickerMaxDate}}" (change)="checkDateRange()">
                                                     -->

                                                    </div>

                                                    <span class="text-danger"
                                                        *ngIf="BirthDay.invalid && (BirthDay.dirty || BirthDay.touched)">{{BirthDayName()}}</span>
                                                </div>
                                            </div>

                                            <div class="row pt-2">

                                                <div class="col-md-12">
                                                    
                                                    <div class="form-group formgroup-tm">
                                                        <label class="customlabel">Business Name </label>
                                                        <input class="formcontrol-user1 form-control" type="text" placeholder="Business Name " id="BusinessName"
                                                            name="BusinessName" [formControl]="BusinessName">
                                                    </div>

                                                    <!-- <span class="text-danger" *ngIf="BusinessName.invalid && (BusinessName.dirty || BusinessName.touched)">{{BusinessNames()}}</span> -->
                                                </div>
                                            </div>

                                            <div class="row pt-2">

                                                <div class="col-md-12">
                                                    
                                                    <div class="form-group formgroup-tm">
                                                        <label class="customlabel">Notes</label>
                                                        <input class="formcontrol-user1 form-control" type="text" placeholder="Notes " id="Notes" name="Notes"  [formControl]="Notes">

                                                    </div>


                                                    <!-- <span class="text-danger"
                                                        *ngIf="Notes.invalid && (Notes.dirty || Notes.touched)">{{Noteserror()}}</span> -->

                                                </div>
                                            </div>

                                            <div class="row pt-2">

                                                <div class="col-md-12  ">
                                                    
                                                    <div class="form-group formgroup-tm">
                                                        <!-- <input type="text" placeholder="Contact Perference " id="ContactPerference" name="ContactPerference"  [formControl]="ContactPerference" required> -->
                                                        <label class="customlabel">Contact Preference
                                                        </label>
                                                        <div class="selectcustom mb-0">
                                                            <ngx-select [items]="contactrefrence" placeholder="Contact Preference"
                                                            id="ContactPerference" name="ContactPerference"
                                                            [formControl]="ContactPerference" required>
                                                        </ngx-select>
                                                        </div>
                                                       

                                                    </div>

                                                </div>
                                            </div>


                                            <div class=" pt-3">
                                                <button class="btn btn dash-btns" type="button" id="savePrepaidCard"
                                                    color="primary"
                                                    [disabled]="CustomerId.invalid||CustomerName.invalid||Email.invalid||mobileerrorvalidation ||BirthDay.invalid  ||isemployee ||Emailerror||mobileerror"
                                                    (click)="newCustomer()">Submit</button>

                                            </div>

                                        </div>
                                    </form>
                                </div>

                                <div class="col-md-12"   *ngIf="isUpdateCustomer">
                                    <form #fnewprepaidcard="ngForm">
                                        <div>
                                            <form #form="ngForm" class="addpaynow">
                                                <div class="form-group formgroup-tm">
                                                    <div class="row pt-2">

                                                        <div class="col-md-12">
                                                            
                                                            <div class="form-group formgroup-tm">
                                                                <label class="customlabel">CustomerId*</label>
                                                                <input class="formcontrol-user1 form-control" type="text" placeholder="CustomerId "
                                                                    [(ngModel)]="rows.CustomerId" id="CustomerId"
                                                                    name="CustomerId" [formControl]="CustomerId"
                                                                    (change)=onChange() readonly>


                                                            </div>
                                                            <div style="color:red;" *ngIf="isemployee">Customer Id is already
                                                                exist</div>

                                                            <span class="text-danger"
                                                                *ngIf="CustomerId.invalid && (CustomerId.dirty || CustomerId.touched)"></span>
                                                        </div>
                                                    </div>

                                                    <div class="row pt-2">
                                                        <div class="col-md-12">
                                                            
                                                            <div class="form-group formgroup-tm">
                                                                <label class="customlabel">Customer Name*</label>
                                                                <input class="formcontrol-user1 form-control" type="text" placeholder="Customer Name "
                                                                    [(ngModel)]="rows.CustomerName" id="CustomerName"
                                                                    name="CustomerName" [formControl]="CustomerName"
                                                                    (keydown)="onKey()" required>

                                                            </div>
                                                            <span class="text-danger"
                                                                *ngIf="CustomerName.invalid && (CustomerName.dirty || CustomerName.touched)">{{customerName()}}</span>
                                                        </div>
                                                    </div>
                                                    <div class="row pt-2">

                                                        <div class="col-md-12">
                                                           
                                                            <div class="form-group formgroup-tm">
                                                                <label class="customlabel">Email</label>
                                                                <input class="formcontrol-user1 form-control" type="text" placeholder="Email " id="Email" name="Email"
                                                                    [formControl]="Email" [(ngModel)]="rows.Email"
                                                                    (keydown)="onKey()"
                                                                    pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$"
                                                                    (change)="onChangeid()">

                                                            </div>
                                                            <div style="color:red;" *ngIf="Emailerror">Email already exist</div>
                                                            <span class="text-danger"
                                                                *ngIf="Email.invalid && (Email.dirty || Email.touched)">{{Emailerrorss()}}</span>
                                                        </div>
                                                    </div>

                                                    <div class="row pt-2">

                                                        <div class="col-md-12">
                                                           
                                                            <div class="form-group formgroup-tm">
                                                                <label class="customlabel">Mobile No *</label>
                                                                <input class="formcontrol-user1 form-control" type="text" placeholder="Mobile No " id="MobileNo"
                                                                    name="MobileNo" maxlength="10" [(ngModel)]="rows.MobileNo"
                                                                    [formControl]="MobileNo" (change)="onChangemobile()"
                                                                    (keydown)="onKey()">

                                                            </div>
                                                            <div style="color:red;" *ngIf="mobileerror">{{Mobileerrormessage}}</div>
                                                            <span class="text-danger"
                                                                *ngIf="MobileNo.invalid && (MobileNo.dirty || MobileNo.touched)">{{phoneerrors()}}</span>
                                                        </div>
                                                    </div>
                                                    <!-- <input type="hidden" [(ngModel)]="rows.id" id="id" name="id"  [formControl]="id">-->
                                                    <!-- <input type="hidden" [(ngModel)]="rows.dateTime" id="date" name="date"  [formControl]="date"> -->
                                                    <div class="row pt-2">
                                                        <div class="col-md-12">
                                                            
                                                            <div class="form-group formgroup-tm">
                                                                <label class="customlabel">Birth Day</label>
                                                                <input class="formcontrol-user1 form-control" type="date" placeholder="Birth Day " id="BirthDay"
                                                                    name="BirthDay" [formControl]="BirthDay"
                                                                    [(ngModel)]="rows.BirthDay" 
                                                                    (keydown)="onKey()">
                                                                <!-- <input type="date"  placeholder="From Date" id="fromdate"
                                                                [formControl]="fromdate" max="{{datePickerMaxDate}}" (change)="checkDateRange()">
                                                                -->
                                                            </div>

                                                            <!-- <span class="text-danger"
                                                                *ngIf="BirthDay.invalid && (BirthDay.dirty || BirthDay.touched)">{{BirthDayName()}}</span> -->
                                                        </div>
                                                    </div>

                                                    <div class="row pt-2">

                                                        <div class="col-md-12">
                                                            <div class="form-group formgroup-tm">
                                                                <label class="customlabel">Business Name </label>
                                                                <input class="formcontrol-user1 form-control" type="text" placeholder="Business Name "
                                                                    id="BusinessName" [(ngModel)]="rows.BusinessName"
                                                                    (keydown)="onKey()" name="BusinessName"
                                                                    [formControl]="BusinessName" required>
                                                            </div>

                                                            <!-- <span class="text-danger" *ngIf="BusinessName.invalid && (BusinessName.dirty || BusinessName.touched)">{{BusinessNames()}}</span> -->
                                                        </div>
                                                    </div>

                                                    <!-- <div class="row pt-2">

                                                    <div class="col-md-5 col-lg-4">
                                                        <label class="customlabel">Adress<span
                                                                class="text-danger">*</span></label>
                                                    </div>

                                                    <div class="col-md-12">
                                                        <div class="form-group formgroup-tm">

                                                        <input type="text" placeholder="Address " [(ngModel)]="rows.address" id="Address" name="Address" [formControl]="Address">
                                                        </div>

                                                        <span class="text-danger" *ngIf="Address.invalid && (Address.dirty || Address.touched)">{{addresserrors()}}</span>
                                                    </div>
                                                </div> -->

                                                    <div class="row pt-2">

                                                        <div class="col-md-12">
                                                            
                                                            <div class="form-group formgroup-tm">
                                                                <label class="customlabel">Notes </label>
                                                                <input class="formcontrol-user1 form-control" type="text" placeholder="Notes " id="Notes" name="Notes"
                                                                    [(ngModel)]="rows.Notes" (keydown)="onKey()"
                                                                    [formControl]="Notes">

                                                            </div>

                                                            <!-- <span class="text-danger"
                                                                *ngIf="Notes.invalid && (Notes.dirty || Notes.touched)">{{Noteserror()}}</span> -->
                                                        </div>
                                                    </div>

                                                    <div class="row pt-2">

                                                        <div class="col-md-12">
                                                           
                                                            
                                                            <div class="form-group formgroup-tm">
                                                                <!-- <input type="text" placeholder="Contact Perference " id="ContactPerference" [(ngModel)]="rows.ContactPerference" name="ContactPerference"  [formControl]="ContactPerference" required> -->
                                                                <label class="customlabel">Contact Preference </label>
                                                                <div class="selectcustom mb-0">
                                                                    <ngx-select [items]="contactrefrence"
                                                                    placeholder="Contact Preference" id="ContactPerference"
                                                                    [(ngModel)]="rows.ContactPerference"
                                                                    name="ContactPerference" (select)="onKey()"
                                                                    [formControl]="ContactPerference" required>
                                                                </ngx-select>
                                                                </div>
                                                          

                                                            </div>

                                                        </div>
                                                    </div>

                                                    <input type="hidden" [(ngModel)]="rows.Id" id="id" name="id"  [formControl]="id">
                                                    <input type="hidden" [(ngModel)]="rows.dateTime" id="date" name="date"  [formControl]="date">
                                                    <div class="pt-3">
                                                        <button class="btn dash-btns" type="button" id="savePrepaidCard"
                                                            color="primary"
                                                            [disabled]="CustomerName.invalid||Email.invalid||MobileNo.invalid  ||Emailerror||mobileerror ||!isReadytoUpdateCustomer "
                                                            (click)="updateCustomer()">Update</button>

                                                    </div>

                                                </div>
                                            </form>

                                        </div>

                                    </form>
                                </div>




                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-5">
                    <div class="card p-2">
                        <div class="text-center">
                           <img src="https://fastswiff.com/assets/img/vpos-tour-images/coupons/manage-coupons.png" class="w-100"  alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

  </div>






<!-- <section >
    <div class="block-header">
        <div class="">
            <div class="row ">
                <div class="col-md-12  p-0">
                    <h2 class="poppins font-weight-bold pl-2">Customer</h2>
                </div>
                <div class=" col-md-5 px-6 col-sm-12 p-0">

                    <div class="breadcrumb flat">
                        <a [routerLink]="['/pos']">

                            Home
                        </a>
                        <a href="#" class="active">New Customer</a>
                    </div>
                </div>
                <div class="col-md-7">
                    <div class="float-right">


                    </div>
                </div>
            </div>
        </div>

    </div>
    <div class="container">
        <div class="row">
            <div class="col-md-12 p-0">
                <div class=" card px-2 py-4 poppins border" style="box-shadow: none; border-radius: 10px;">
                    <div class="row mx-0">

                    </div>
                    <div class="row mx-0">


                        <div class="col-md-5">
                            <div class="b">
                                <img src="assets/img/payment-solutions.png" alt="Tips"
                                    style="display: block; width: 100%;">
                            </div>

                        </div>



                    </div>
                </div>
            </div>
        </div>
    </div>
</section>  -->